// extracted by mini-css-extract-plugin
module.exports = {"copyTextContainer":"CopyText_copyTextContainer__nIplX","copyTextInput":"CopyText_copyTextInput__OozTM"};